<div class="page">
  <div class="header">
    <h1 class="header-title">
      @if (showBackButton()) {
        <button class="schedule-back" mat-icon-button aria-label="Terug" (click)="goBack()" style="color: inherit">
          <mat-icon>arrow_back</mat-icon>
        </button>
      }
      <mat-icon>person_search</mat-icon>
      <span>Rooster medewerkers</span>
    </h1>
    @if (canSendSchedule()) {
      <div class="header-buttons">
        <button
          class="header-button send-schedule-button"
          mat-icon-button
          aria-label="Rooster versturen"
          (click)="openSendScheduleDialog()"
        >
          <mat-icon>send</mat-icon>
          <span class="button-text">Rooster versturen</span>
        </button>
      </div>
    }
  </div>
  <mat-card class="content">
    <div class="content-header">
      <mat-chip-set class="role-chips">
        <mat-chip
          [class.chip-selected]="selectedRole() === RoleEnum.Driver"
          role="button"
          tabindex="0"
          aria-label="Filter op chauffeurs"
          [attr.aria-pressed]="selectedRole() === RoleEnum.Driver"
          (click)="toggleRole(RoleEnum.Driver)"
          (keydown.enter)="toggleRole(RoleEnum.Driver)"
          (keydown.space)="$event.preventDefault(); toggleRole(RoleEnum.Driver)"
          >Chauffeurs</mat-chip
        >
        @if (dataStore.generalSettings.coDriverEnabled) {
          <mat-chip
            [class.chip-selected]="selectedRole() === RoleEnum.CoDriver"
            role="button"
            tabindex="0"
            aria-label="Filter op bijrijders"
            [attr.aria-pressed]="selectedRole() === RoleEnum.CoDriver"
            (click)="toggleRole(RoleEnum.CoDriver)"
            (keydown.enter)="toggleRole(RoleEnum.CoDriver)"
            (keydown.space)="$event.preventDefault(); toggleRole(RoleEnum.CoDriver)"
            >Bijrijders</mat-chip
          >
        }
        <mat-chip
          [class.chip-selected]="selectedRole() === RoleEnum.Planner"
          role="button"
          tabindex="0"
          aria-label="Filter op planners"
          [attr.aria-pressed]="selectedRole() === RoleEnum.Planner"
          (click)="toggleRole(RoleEnum.Planner)"
          (keydown.enter)="toggleRole(RoleEnum.Planner)"
          (keydown.space)="$event.preventDefault(); toggleRole(RoleEnum.Planner)"
          >Planners</mat-chip
        >
      </mat-chip-set>
      <mat-form-field class="mat-form-field-no-subscript">
        <mat-label class="placeholder">Zoeken</mat-label>
        <input matInput placeholder="Zoeken" autocomplete="off" [formControl]="searchControl" />
        <button
          mat-icon-button
          matSuffix
          aria-label="Zoekopdracht wissen"
          (click)="clearSearch(); $event.stopPropagation()"
        >
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="list-items">
      <div class="list-item-row headers">
        <div class="list-item-col icon-col"></div>
        <div class="list-item-col">Naam</div>
        <div class="list-item-col">E-mail</div>
        <div class="list-item-col hide-column">Telefoonnummer</div>
        <div class="list-item-col role-col hide-column-2">Rollen</div>
        <div class="list-item-col action-col"></div>
      </div>
      <cdk-virtual-scroll-viewport itemSize="50" class="list-wrapper">
        @for (employee of filteredEmployees(); track employee.id) {
          <div
            class="list-item-row"
            role="button"
            tabindex="0"
            aria-label="Medewerker openen"
            (click)="openEmployee(employee)"
            (keydown.enter)="openEmployee(employee)"
            (keydown.space)="$event.preventDefault(); openEmployee(employee)"
          >
            <div class="list-item-col icon-col">
              <div class="icons-wrapper">
                <div class="circle-icon primary-bg">
                  {{ (employee.name ?? '?').charAt(0).toUpperCase() }}
                </div>
              </div>
            </div>
            <div class="list-item-col">{{ employee.name ?? '' }} {{ employee.lastName ?? '' }}</div>
            <div class="list-item-col">{{ employee.email ?? '' }}</div>
            <div class="list-item-col hide-column">{{ employee.phone ?? employee.phoneNumber ?? '' }}</div>
            <div class="list-item-col role-col hide-column-2">
              <mat-chip-set>
                @for (
                  role of (employee.roles ?? []).filter(r => [RoleEnum.Driver, RoleEnum.CoDriver, RoleEnum.Planner, RoleEnum.RidePlanner].includes(r));
                  track role
                ) {
                  <mat-chip class="text-truncate">{{ getRoleLabel(role) }}</mat-chip>
                }
              </mat-chip-set>
            </div>
            <div class="list-item-col list-item-buttons action-col">
              <mat-icon>visibility</mat-icon>
            </div>
          </div>
        }
      </cdk-virtual-scroll-viewport>
    </div>
  </mat-card>
</div>
